import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import { useSelector } from "react-redux";
import {Activity ,Plus ,Youtube } from 'lucide-react';
import SnackbarSidebar from "../../../../SnackbarSidebar";
import AddDemoVideosAddMoreSubCourse from "./AddDemoVideosAddMoreSubCourse";
const AddDemoVideosSubCourse = ({sendBackData,data})=>{
  const {courseId} = useParams();
//   const {url}=useRouteMatch();
  const history = useHistory();
 const dispatch = useDispatch();  
 const [snackbarVisible, setSnackbarVisible] = useState(false);
 const [snackbarColor, setSnackbarColor] = useState("#958FDA");
 const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 const showSnackbar = () => {
  setSnackbarVisible(true);
};

 const hideSnackbar = () => {
  setSnackbarVisible(false);
};
const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);

 const AppToken = useSelector((state)=>state?.app?.app?.AppToken);

function generateTimestamp() {
    return Math.floor(Date.now() / 1000);
  }
 
 const [itemArr, setItemArr] = useState(courseData?.CourseVideoLinks);

 const [selectedItemIndex, setSelectedItemIndex] = useState(null); // Track hovered drop zone
 
 useEffect(() => {
  
 }, []);

 const removeItem = (id) => {
    const filteredItems = itemArr.filter(item => item?.id !== id);
    setItemArr(filteredItems);
  };
  const updateItemTotalNumber = (id, newTotalNumber) => {
    const updatedItems = itemArr.map(item =>
      item?.id === id ? { ...item, totalNumber: newTotalNumber } : item
    
    ); 
    setItemArr(updatedItems);
  };const updateItemTitle = (id, newTitle) => {
    const updatedItems = itemArr.map(item =>
      item?.id === id ? { ...item, youtubeLinkTitle :newTitle } : item
    
    ); 
   // console.log(updatedItems)
    setItemArr(updatedItems);
  };
  const updateItemLink = (id, newLink) => {
    const updatedItems = itemArr.map(item =>
      item?.id === id ? { ...item, youtubeLink :newLink } : item
    
    ); 
    setItemArr(updatedItems);
  };
  const updateItemStatus = (id, status) => {
    const updatedItems = itemArr.map(item =>
      item?.id === id ? { ...item, status: status } : item
    
    );



    setItemArr(updatedItems);

    
    setTimeout(()=>{
    //   console.log(updatedItems)
          },1000)
  };
  const flattenedData = itemArr!=[]?Object.values(itemArr):'';






useEffect(()=>{
  // setCourseTitleData();
// console.log(itemArr)
data?.length !== 0?setItemArr(data):
  setItemArr([{ no:1, id: generateTimestamp(), status:false,contentIcon:`Video`
    ,youtubeLink:"https://www.youtube.com/watch?v=Bn-3ICGjz0U" ,youtubeLinkTitle:"The Weeknd - Open Hearts (Official Video)",editable:true},
   
    
    // { no:2, id: generateTimestamp()+1, status:false,contentIcon:`Video`
    //     ,youtubeLink:"" ,editable:true},
]);
},[])



const handleCourseDemoVideos=(e)=>{

sendBackData(itemArr)
 
  }

  const [position, setPosition] = useState({ x: 0, y: 0 });
  
  const [draggedIndex, setDraggedIndex] = useState('');
  const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

  const handleDragStart = (e, index) => {
    
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData("dragIndex", index);
    
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    if (dragIndex === dropIndex) return;

    const updatedItems = [...itemArr];
    const [draggedItem] = updatedItems.splice(dragIndex, 1);
    updatedItems.splice(dropIndex, 0, draggedItem);

    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      id: item?.id,
    }));
    setItemArr(reorderedItems);
    setDraggedIndex('');
    setHoveredDropZone(null); // Reset hovered drop zone
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
     // Set the hovered drop zone
  };

  const handleDragEnd = () => {
    setDraggedIndex('');
    setHoveredDropZone(null); // Clear hovered drop zone
  };
   
    return <>
    
{<>

{snackbarVisible && (
        <SnackbarSidebar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
      
     <div className="" >
           
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item?.id} 
          ><div
          className="drop-zone"
          onDragOver={(e) => {setHoveredDropZone(index);
            handleDragOver(e, index)
          }}
          onDrop={(e) => handleDrop(e, index)}
        
          style={{
            height: hoveredDropZone === index ?'200px':"0px",position:hoveredDropZone === index ?'relative':"",left:"0px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"10px":"0px"
           
          }}
        ></div>
            <div
             draggable 
             
onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}

             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item?.id);setSelectedItemIndex(index);
             }}
             style={{
              cursor: 'move',width:"100%",
              // backgroundColor: hoveredDropZone === index+1 ? "#f1f1f1":
              // hoveredDropZone === index ?"#f1f1f1":"",
              // transform: hoveredDropZone === index+1 ? "scale(0.90)":
              // hoveredDropZone === index ?"scale(0.90)":"",
              // // marginTop: hoveredDropZone === index+1 ? "-10px":
              // hoveredDropZone === index ?"10px":"",
             
              
            }}  className={draggedIndex == item?.id?"posFixed":"posRelative"  }
          
              onDragEnd={handleDragEnd}
            ><AddDemoVideosAddMoreSubCourse index={index} key={item?.id} 
         changeItemStatus ={updateItemStatus } 
          youtubeLink={item?.youtubeLink} youtubeLinkTitle={item?.youtubeLinkTitle} no={item?.no} id={item?.id} totalNumber={item?.totalNumber} status={item?.status} 
          contentIcon={item?.contentIcon}  editable={item?.editable}  changeItemTitle={updateItemTitle } changeItemLink={updateItemLink } onRemove={removeItem} />
          </div>
          
          </div>)):'' }
    
    <div align="center">
<div align="center"  style={{width:"100%",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New Youtube Link</div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>setItemArr([...itemArr, {no: itemArr.length, id: generateTimestamp()+2
      , totalNumber: 0,status:true,contentIcon:`Video`,
      youtubeLink:"" ,youtubeLinkTitle:"",editable:true}])}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
    </div>
    </div> 
    <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div></div>

<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleCourseDemoVideos()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> Update Info </button>
 </div>
  

{/* <div className="gridForSidebarItemBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   
 
 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={handleCourseDemoVideos} style={{width:"140px",height:"55px"}} 
     className="buttonFillSidebar"  type="submit"
     id="signupBtn"> {loader?.status?"saving...":"Click To Save"} </button>
  </div> */}
    
      
</>}
    </>

}
export default AddDemoVideosSubCourse;
